export const SINGLE_ACTION_DISPATCHED = 'SINGLE_ACTION_DISPATCHED';